import React from "react";
import NavPublicUser from "../navbarPublicUser"
import PubOrderBody from "../PubOrderBody";
import Footer from "../Footer";
export default function PubOrder(){

return(
<div >
<NavPublicUser />
<PubOrderBody />
<Footer />
</div>   

)


}